import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import firebase from "firebase";


import {
  LOAD_FILE_LIST,DELETE_FILE
} from "constants/ActionTypes";

import {
  loadFileListSuccess,deleteFile,deleteFileSuccess
} from "../actions/MyFiles";

export function* deletFile() {
  yield takeEvery(DELETE_FILE, deleteFileById);
}

function* deleteFileById({ payload }) {
  
  const folderID= localStorage.getItem('folder_id');
  const userID = localStorage.getItem('user_id');
  const projectID= localStorage.getItem('project_id');

  var fileRef = firebase.database().ref('/folder_detail/' + userID + '/'+projectID+'/'+folderID+'/'+payload);
  fileRef.remove();
  yield put( deleteFileSuccess() );
}

export function* loadMyFiles() {
  yield takeEvery(LOAD_FILE_LIST, loadFileByID);
}

function* loadFileByID({ payload }) {

  const { userID, folderID } = payload;

  console.log("############FILE_SAGA - Folder ID: "+folderID);
  console.log("############FILE_SAGA - USER ID: "+userID);

  const projectID= localStorage.getItem('project_id');
  try {

    var foldersRef = firebase.database().ref('/folder_detail/' + userID + '/'+projectID+'/'+folderID)
    var files = yield call(function () {
      return new Promise(function (resolve, reject) {
        foldersRef.once('value', function (snap) {

          var files = snap;

          console.log("############FILE_SAGA - SNAPSHOT: "+JSON.stringify(snap));

          resolve(files)
        })
      })
    })
    yield put(loadFileListSuccess(files))

  } catch (error) {

  }

}

export default function* rootSaga() {
  yield all([fork(loadMyFiles),
    fork(deletFile)
  
  ]);
}

